export default function EmptyState({ title, description, action, illustration }) {
  return (
    <div className="tk-soft-card flex flex-col items-center text-center py-10 sm:py-14" data-testid="empty-state">
      <div className="w-24 h-24 mb-5 rounded-full bg-sage-100 flex items-center justify-center">
        {illustration || (
          <svg viewBox="0 0 64 64" className="w-12 h-12 text-sage-500" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M32 52V28" />
            <path d="M32 28C28 18 20 16 14 16C14 26 22 32 32 32" />
            <path d="M32 28C36 18 44 16 50 16C50 26 42 32 32 32" />
            <path d="M16 52H48" />
          </svg>
        )}
      </div>
      <h3 className="font-outfit text-xl text-ink-900 mb-2">{title}</h3>
      {description && (
        <p className="font-dmsans text-sm text-ink-600 max-w-md leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
